<template>
  <div>
    <spinner-component :loading="loading"></spinner-component>
    <error-dialog-component :model-value="this.errorDialog"></error-dialog-component>
    <edit-popup-content-view v-if="popupContent" :popup-content-prop="popupContent"></edit-popup-content-view>
  </div>
</template>

<script>

import SpinnerComponent from "@/components/SpinnerComponent";
import ErrorDialogComponent from "@/components/ErrorDialogComponent";
import EditPopupContentView from "@/views/popup/EditPopupContentView";
import {popupApiClient} from "@/api/popup.api.client";

export default {
  name: 'EditPopupContentWrapper',

  components: {
    SpinnerComponent,
    ErrorDialogComponent,
    EditPopupContentView
  },

  props: {
    id: String
  },

  data() {
    return {
      popupContent: null,
      loading: false,
      errorDialog: {
        errorMessage: "",
        visible: false
      }
    }
  },

  created() {
    this.loadPopupContent();
  },

  methods: {
    loadPopupContent() {
      this.loading = true;
      popupApiClient.getPopupContent(
          this.id,
          (response) => {
            this.popupContent = response.data;
          },
          () => {
            this.errorDialog.visible = true;
            this.errorDialog.errorMessage = "Błąd pobierania popupu!";
          },
          () => this.loading = false
      );
    }
  }
}
</script>

<style scoped>
</style> 